// extracted by mini-css-extract-plugin
export default {"header":"style_header__fiGbR","siteLayoutBackground":"style_siteLayoutBackground__+HKtk","sider":"style_sider__eb0rf"};